export const validImage = (file) => file.type.includes('image') && file.size < 5000 * 1000;
